import type { EnrollmentTokenResult } from '../../api';

/**
 * 발급한 기기 등록 토큰 안내(1회만 보이는 값) — 그룹 메뉴 [이 그룹에 기기 등록](설계서 §14.20) 결과.
 * @param groupLabel 이 토큰으로 등록된 기기가 들어갈 그룹 경로
 */
export function EnrollTokenNotice({
  token,
  groupLabel,
  onClose,
}: {
  token: EnrollmentTokenResult;
  groupLabel: string;
  onClose: () => void;
}) {
  return (
    <div className="enroll-token gtree-notice" onClick={(e) => e.stopPropagation()}>
      <div className="hint" style={{ marginBottom: 4 }}>
        <b>{groupLabel}</b> 에 등록할 토큰(최대 {token.maxUses}회, 만료 {new Date(token.expiresAt).toLocaleString()}). 이 값은 지금만 표시됩니다:
      </div>
      <code className="token-value" title="클릭하여 복사" onClick={() => navigator.clipboard?.writeText(token.enrollmentToken)}>
        {token.enrollmentToken}
      </code>
      <div className="hint" style={{ marginTop: 6 }}>
        기기에서 <code>RS_AGENT_ENROLLMENT_TOKEN</code> 환경변수로 설정 후 실행하면 이 그룹에 등록됩니다. 그룹을 지우면 이 토큰도 무효가 됩니다.{' '}
        <button className="linklike" onClick={onClose}>
          닫기
        </button>
      </div>
    </div>
  );
}
